import { render } from "./HostgroupsDetails.vue?vue&type=template&id=51341c42&scoped=true"
import script from "./HostgroupsDetails.vue?vue&type=script&lang=js"
export * from "./HostgroupsDetails.vue?vue&type=script&lang=js"

import "./HostgroupsDetails.vue?vue&type=style&index=0&id=51341c42&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51341c42"]])

export default __exports__